import {
	GREEK_CHARACTERS,
	GREEK_SYLLABLES_TO_LATIN_ELOT_743,
	LATIN_CHARACTERS,
} from "./greek-to-latin-characters-input-value.const";

export function toGreeklish(text: string): string {
	const TRANSLATION_DICTIONARY = new Map<string, string>();

	for (let i = 0; i < GREEK_CHARACTERS.length; i++) {
		TRANSLATION_DICTIONARY.set(GREEK_CHARACTERS[i], LATIN_CHARACTERS[i]);
	}

	for (const [pattern, replacement] of GREEK_SYLLABLES_TO_LATIN_ELOT_743) {
		text = text.replace(new RegExp(pattern, "g"), replacement);
	}

	for (const [greekChar, englishChar] of TRANSLATION_DICTIONARY) {
		text = text.replace(new RegExp(greekChar, "g"), englishChar);
	}

	return text;
}
